import { useEffect, useState } from "react";
import { api } from "../services/api";
import { 
  Save, 
  Loader2, 
  Plus, 
  Trash2, 
  Link, 
  LayoutTemplate 
} from "lucide-react";
import "./Dashboard.css";

export default function AcessoRapido() {
  const [menuItems, setMenuItems] = useState([]);
  const [registroId, setRegistroId] = useState(null); // Guarda o ID da tabela acesso_rapido (se existir)
  const [isLoading, setIsLoading] = useState(false);
  const [isFetching, setIsFetching] = useState(true);

  const clienteId = localStorage.getItem("siteId");

  useEffect(() => {
    loadAcessoRapido();
  }, []);

  async function loadAcessoRapido() {
    if (!clienteId) return;
    
    try {
      const response = await api.get(`/acessos-rapidos/cliente/${clienteId}`);
      setRegistroId(response.data.id);
      setMenuItems(response.data.botoes_menu || []);
    } catch (error) {
      // Se retornar 404, significa que o cliente ainda não tem botões configurados
      if (error.response?.status === 404) {
        setRegistroId(null);
        setMenuItems([]);
      } else {
        console.error("Erro ao carregar acesso rápido:", error);
      }
    } finally {
      setIsFetching(false);
    }
  }

  const handleAddItem = () => {
    setMenuItems([
      ...menuItems, 
      { nome: "", ativo: true, tipo_acesso: "link", conteudo: "", icone: "lei" }
    ]);
  };

  const handleRemoveItem = (index) => {
    const newItems = [...menuItems];
    newItems.splice(index, 1);
    setMenuItems(newItems);
  };

  const handleChange = (index, field, value) => {
    const newItems = [...menuItems];
    newItems[index][field] = value;
    setMenuItems(newItems);
  };

  const handleSave = async () => {
    setIsLoading(true);
    try {
      const payload = {
        cliente_id: clienteId,
        botoes_menu: menuItems
      };

      if (registroId) {
        // Atualiza registro existente
        await api.put(`/acessos-rapidos/${registroId}`, payload);
      } else {
        // Cria novo registro
        const response = await api.post("/acessos-rapidos", payload);
        setRegistroId(response.data.id);
      }
      alert("Menu de acesso rápido salvo com sucesso!");
    } catch (error) {
      console.error(error);
      alert("Erro ao salvar as configurações.");
    } finally {
      setIsLoading(false);
    }
  };

  if (isFetching) {
    return (
      <div className="dashboard-loading">
        <Loader2 className="spinner" size={40} />
        <p>Carregando botões...</p>
      </div>
    );
  }

  return (
    <div className="dashboard-container">
      <div className="dashboard-wrapper">
        
        <div className="dashboard-header">
          <div className="dashboard-title">
            <h1>Acesso Rápido</h1>
            <p>Configure os botões de atalho da página inicial.</p>
          </div>
          <button className="btn btn-secondary" onClick={handleAddItem}>
            <Plus size={18} /> Adicionar Botão
          </button>
        </div>

        <div className="config-card">
          <div className="section-title">
            <LayoutTemplate size={18} />
            <h3>Lista de Botões</h3>
          </div>

          {menuItems.length === 0 ? (
            <p style={{ color: "var(--color-text-light)", textAlign: "center", padding: "2rem 0" }}>
              Nenhum botão configurado. Clique em "Adicionar Botão" para começar.
            </p>
          ) : (
            <div style={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}>
              {menuItems.map((item, index) => (
                <div key={index} style={{ border: "1px solid var(--color-border)", padding: "1.5rem", borderRadius: "var(--radius)", background: "#f8fafc" }}>
                  <div className="config-grid" style={{ gap: "1.5rem", gridTemplateColumns: "1fr 1fr 1fr" }}>
                    
                    <div className="form-group">
                      <label className="form-label">Nome de Exibição</label>
                      <input 
                        className="form-input" 
                        value={item.nome} 
                        onChange={(e) => handleChange(index, "nome", e.target.value)} 
                        placeholder="Ex: LEGISLAÇÃO" 
                      />
                    </div>

                    <div className="form-group">
                      <label className="form-label">Tipo de Acesso</label>
                      <select 
                        className="form-input" 
                        value={item.tipo_acesso} 
                        onChange={(e) => handleChange(index, "tipo_acesso", e.target.value)}
                      >
                        <option value="link">Link Externo</option>
                        <option value="interno">Rota Interna</option>
                        <option value="modal">Modal (Popup)</option>
                      </select>
                    </div>

                    <div className="form-group">
                      <label className="form-label">Ícone</label>
                      <select 
                        className="form-input" 
                        value={item.icone} 
                        onChange={(e) => handleChange(index, "icone", e.target.value)}
                      >
                        <option value="lei">Lei (Balança)</option>
                        <option value="calendario">Calendário</option>
                        <option value="consulta">Consulta/Lupa</option>
                        <option value="site_prefeitura">Prédio/Prefeitura</option>
                        <option value="mensagem">Mensagem/Ouvidoria</option>
                        <option value="processo">Processo/e-SIC</option>
                        <option value="documento">Documento/Cheque</option>
                        <option value="site_percept">Logo Percept</option>
                        <option value="interrogacao">Interrogação/FAQ</option>
                        <option value="envelope">Envelope/Serviços</option>
                      </select>
                    </div>
                  </div>

                  <div className="config-grid" style={{ gap: "1.5rem", gridTemplateColumns: "1fr auto" }}>
                    <div className="form-group" style={{ marginBottom: 0 }}>
                      <label className="form-label">
                        <Link size={14} className="inline-icon" /> Conteúdo / Rota
                      </label>
                      <input 
                        className="form-input" 
                        value={item.conteudo} 
                        onChange={(e) => handleChange(index, "conteudo", e.target.value)} 
                        placeholder="https://... ou /rota-interna" 
                      />
                    </div>

                    <div style={{ display: "flex", alignItems: "flex-end", gap: "1rem" }}>
                      <label style={{ display: "flex", alignItems: "center", gap: "0.5rem", cursor: "pointer", fontWeight: 500 }}>
                        <input 
                          type="checkbox" 
                          checked={item.ativo} 
                          onChange={(e) => handleChange(index, "ativo", e.target.checked)} 
                          style={{ width: "18px", height: "18px" }}
                        />
                        Ativo
                      </label>
                      
                      <button className="btn btn-danger btn-sm" onClick={() => handleRemoveItem(index)}>
                        <Trash2 size={16} /> Remover
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}

          <div className="config-footer">
            <button className="btn btn-primary" disabled={isLoading} onClick={handleSave}>
              {isLoading ? (
                <><Loader2 className="spinner" size={18} /> Salvando...</>
              ) : (
                <><Save size={18} /> Salvar Alterações</>
              )}
            </button>
          </div>

        </div>
      </div>
    </div>
  );
}